import BetssonSettings from '@/modules/integrations/types/betsson/BetssonSettings'

export default Object.freeze({
  type: 'betsson',
  title: 'Integrations_Betsson',
  category: 'Integrations_Betsson_Category',
  description: 'Integrations_Betsson_Description',
  image: require('@/img/integrations/betsson.png'),
  requiresAdmin: false,
  components: {
    settings: BetssonSettings,
    overview: null
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/betsson/index.js